'use strict';

module.exports = function ($stateProvider) {
    $stateProvider
    // STEALTH
        // STEALTH DEPLOY CONFIG
        .state('pages.main.stealth_deploy_config', {
            url: '/stealth_deploy_config',
            template: require('../views/stealth/stealth_deploy_config.html'),
            controller: 'stealthDeployConfigController',
            controllerAs: 'page',
            data: {
                title: 'Stealth Deployment Configuration',
                daterange: true
            }
        })
        // STEALTH OP VIEW
        .state('pages.main.stealth_op_view', {
            url: '/stealth_op_view',
            template: require('../views/stealth/stealth_op_view.html'),
            controller: 'stealthOpViewController',
            controllerAs: 'page',
            data: {
                title: 'Stealth Operational View',
                daterange: true
            }
        })
        // STEALTH CONN
        .state('pages.main.stealth_conn', {
            url: '/stealth_conn',
            template: require('../views/stealth/stealth_conn.html'),
            controller: 'stealthConnController',
            controllerAs: 'page',
            data: {
                title: 'Stealth User Connections',
                daterange: true
            }
        })
            // STEALTH CONN ORIG
            .state('pages.main.stealth_conn_orig', {
                url: '/stealth_conn_orig',
                template: require('../views/stealth/stealth_conn_orig.html'),
                controller: 'stealthConnOrigController',
                controllerAs: 'page',
                data: {
                    title: 'Stealth Origin User Connections',
                    daterange: true
                }
            })
        // STEALTH EVENTS
        .state('pages.main.stealth_events', {
            url: '/stealth_events',
            template: require('../views/stealth/stealth_events.html'),
            controller: 'stealthEventsController',
            controllerAs: 'page',
            data: {
                title: 'Stealth Events',
                daterange: true
            }
        })
            // STEALTH EVENTS ORIG
            .state('pages.main.stealth_events_orig', {
                url: '/stealth_events_orig',
                template: require('../views/stealth/stealth_events_orig.html'),
                controller: 'stealthEventsOrigController',
                controllerAs: 'page',
                data: {
                    title: 'Stealth Events Origin',
                    daterange: true
                }
            })
}




/** WEBPACK FOOTER **
 ** ./src/pages/routes/stealth.js
 **/